import { Box, Title } from '@nimbus-ds/components';
import {
  NotificationsListItemResponseDto,
  NotificationDto,
} from '@tiendanube/common';
import { EmailNotificationType } from '@tiendanube/common/src/enums';
import FeatureFlag from 'App/components/FeatureFlag';
import { NEW_ADMIN_INVOICES } from 'App/featuresFlags';
import { Stack } from 'commons/components';
import { CONFIGURATIONS_ROUTES } from 'domains/Configurations/configurationsRoutes';
import {
  SectionAppCard,
  SectionAppCardDomains,
} from 'domains/PartnersApps/components';
import EmailItemCard from './EmailItemCard';

interface EmailsSectionProps {
  title: string;
  emails: NotificationsListItemResponseDto[];
  whatsappNotifications?: NotificationDto[];
  showApp?: boolean;
}

function EmailsSection({
  title,
  emails,
  whatsappNotifications,
  showApp,
}: Readonly<EmailsSectionProps>) {
  const orderInvoiceEmails = emails.filter(
    (email) => email.type === EmailNotificationType.ORDER_INVOICE,
  );
  const otherEmails = emails.filter(
    (email) => email.type !== EmailNotificationType.ORDER_INVOICE,
  );

  return (
    <Stack column align="flex-start" spacing="loose">
      <Title as="h3">{title}</Title>
      <Box
        display="grid"
        gridTemplateColumns={{
          lg: 'repeat(3, 1fr)',
          md: 'repeat(2, 1fr)',
          xs: '1fr',
        }}
        gridGap="4"
        width="100%"
      >
        {otherEmails.map((email) => (
          <EmailItemCard
            key={email.id}
            email={email}
            whatsappNotification={whatsappNotifications?.find(
              (notification) => notification.type === email.type,
            )}
          />
        ))}
        <FeatureFlag flag={NEW_ADMIN_INVOICES}>
          <>
            {orderInvoiceEmails.map((email) => (
              <EmailItemCard
                key={email.id}
                email={email}
                whatsappNotification={whatsappNotifications?.find(
                  (notification) => notification.type === email.type,
                )}
              />
            ))}
          </>
        </FeatureFlag>

        {showApp && (
          <SectionAppCard
            source={CONFIGURATIONS_ROUTES.notifications}
            appCategory="accounting"
            domain={SectionAppCardDomains.EMAILS}
          />
        )}
      </Box>
    </Stack>
  );
}

export default EmailsSection;
